import { render } from "./UpdateInfo.vue?vue&type=template&id=435196f6&scoped=true"
import script from "./UpdateInfo.vue?vue&type=script&lang=js"
export * from "./UpdateInfo.vue?vue&type=script&lang=js"

import "./UpdateInfo.vue?vue&type=style&index=0&id=435196f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435196f6"]])

export default __exports__